import { SLOGANS } from "../data/site";

export default function Marquee() {
  return (
    <div className="overflow-hidden border-y border-white/[0.08] bg-brand-coal py-6 md:py-8">
      <div className="marquee-track flex w-max">
        {[0, 1].map((dup) => (
          <div
            key={dup}
            aria-hidden={dup === 1}
            className="flex items-center gap-8 pr-8 md:gap-14 md:pr-14"
          >
            {SLOGANS.map((s, i) => (
              <span key={i} className="flex items-center gap-8 md:gap-14">
                <span className="font-display text-2xl md:text-4xl italic text-brand-cream/90 whitespace-nowrap">
                  {s}
                </span>
                <span className="block h-2 w-2 rotate-45 bg-brand-orange shrink-0" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
